class ScheduleController implements ng.IComponentController {

    constructor(
    ) {
        'ngInject';
    }

}

export const scheduleComponent: ng.IComponentOptions = {
    controller: ScheduleController,
    template: <string>require('./schedule.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/schedule/schedule.component.ts